import type PaymentType from "./paymentType";

export default class Payment {
  amount: number;
  currencyCode: string;
  paymentType: PaymentType;
  senderName?: string;
}
